"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden lg:flex gap-10">
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <NavigationMenu viewport={false} className="hidden lg:flex">
        <NavigationMenuList className="gap-10">
          {menuItems.slice(0, 5).map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative text-foreground/90 hover:text-foreground text-base font-medium transition-colors duration-[var(--duration-medium)] group hover:!bg-transparent focus:!bg-transparent">
                  {item.label}
                  <span className="absolute left-0 bottom-[-4px] h-[1px] w-0 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      <Button variant="ghost" size="icon" className="lg:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-7" /> : <Menu className="size-7" />}
      </Button>

      {mobileMenuOpen && <div className="absolute top-full left-0 w-full bg-background/95 backdrop-blur-md border-t border-muted lg:hidden">
          <nav className="container mx-auto px-7 py-7 flex flex-col gap-5">
            {menuItems.slice(0, 5).map(item => <Link key={item.id} to={item.href || "#"} className="text-foreground/90 hover:text-foreground text-lg font-medium transition-colors hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
            <Button className="mt-2 w-full" size="lg">
              Commencer une conversation stratégique
            </Button>
          </nav>
        </div>}
    </>;
}
export default function EnTete() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${scrolled ? "h-8 bg-background/80 backdrop-blur-lg shadow-medium" : "h-11 bg-background/60 backdrop-blur-sm"}`}>
      <div className="container mx-auto px-7 h-full flex items-center justify-between">
        <Link to="/" className="flex-shrink-0 hover:!bg-transparent focus:!bg-transparent">
          <img src="https://healthy-mustang.10web.cloud/wp-content/uploads/2026/01/Logo-NorthStar-Advisory-White-transparent-texte-seul-1.png" alt="NorthStar Advisory" className="h-[1.4rem]" />
        </Link>

        <MenuProvider menu_id="3" className="flex items-center gap-10">
          <HeaderMenuConsumer />
        </MenuProvider>

        
      </div>
    </header>;
}